import { render, staticRenderFns } from "./common-modal.vue?vue&type=template&id=72da0bde&scoped=true&lang=pug&"
import script from "./common-modal.vue?vue&type=script&lang=js&"
export * from "./common-modal.vue?vue&type=script&lang=js&"
import style0 from "./common-modal.vue?vue&type=style&index=0&id=72da0bde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72da0bde",
  null
  
)

export default component.exports